// Vendors
import { convertPxsToRems } from '@openbank/cf-ui-framework';
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';
import styled from 'styled-components';

const LayoutContentStyled = styled.div`
  max-width: ${convertPxsToRems({ pixels: 660, base: 16 })};
  margin: 0 auto;
  text-align: center;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    max-width: 100%;
    margin: 0;
    width: 100%;
  }
`;
LayoutContentStyled.displayName = 'LayoutContentStyled';

const HeaderLayoutContentFullHeightStyled = styled.section`
  align-items: center;
  display: flex;
  height: calc(100vh - ${({ theme }) => theme.spacing_500});
  justify-content: center;
  text-align: center;
  width: 100%;
`;
HeaderLayoutContentFullHeightStyled.displayName = 'HeaderLayoutContentFullHeightStyled';

const TextBoldComponentStyled = styled.b`
  font-weight: ${({ theme }) => theme.font_weight_bold};
`;
TextBoldComponentStyled.displayName = 'TextBoldComponentStyled';

export { HeaderLayoutContentFullHeightStyled, LayoutContentStyled, TextBoldComponentStyled };
